import React from 'react';
import { Modal } from 'antd';
import styles from './asset/termsOfServiceModal.module.scss';

const TermsOfServiceModal = ({ isOpen, onClose }) => {
    return (
        <Modal
            open={isOpen}
            onCancel={onClose}
            footer={null}
            width={800}
            centered
            className={styles.tosModal}
        >
            <div className={styles.modalContent}>
                <h1 className={styles.title}>Terms of Service</h1>
                <p className={styles.lastUpdated}>Last Updated: November 4, 2025</p>

                <div className={styles.section}>
                    <h2 className={styles.sectionTitle}>1. Acceptance of Terms</h2>
                    <p className={styles.text}>
                        Welcome to Prepal! By accessing or using our AI-powered test preparation platform, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
                    </p>
                </div>

                <div className={styles.section}>
                    <h2 className={styles.sectionTitle}>2. Description of Service</h2>
                    <p className={styles.text}>
                        Prepal provides personalized AI-driven test preparation services for standardized tests including SAT and IELTS. Our platform offers adaptive learning, practice tests, performance analytics, and personalized study recommendations to help students achieve their target scores.
                    </p>
                </div>

                <div className={styles.section}>
                    <h2 className={styles.sectionTitle}>3. User Accounts</h2>
                    <p className={styles.text}>
                        To access certain features of Prepal, you must create an account. You are responsible for:
                    </p>
                    <ul className={styles.list}>
                        <li>Maintaining the confidentiality of your account credentials</li>
                        <li>All activities that occur under your account</li>
                        <li>Notifying us immediately of any unauthorized use</li>
                        <li>Providing accurate and complete registration information</li>
                    </ul>
                </div>

                <div className={styles.section}>
                    <h2 className={styles.sectionTitle}>4. Subscription and Payment</h2>
                    <p className={styles.text}>
                        Prepal offers various subscription plans. By subscribing, you agree to:
                    </p>
                    <ul className={styles.list}>
                        <li>Pay all fees associated with your chosen plan</li>
                        <li>Automatic renewal unless cancelled before the renewal date</li>
                        <li>Our refund policy as outlined in your subscription agreement</li>
                        <li>Price changes with 30 days advance notice</li>
                    </ul>
                </div>

                <div className={styles.section}>
                    <h2 className={styles.sectionTitle}>5. Acceptable Use</h2>
                    <p className={styles.text}>
                        You agree not to:
                    </p>
                    <ul className={styles.list}>
                        <li>Share your account credentials with others</li>
                        <li>Copy, reproduce, or redistribute our content without permission</li>
                        <li>Use our service for any illegal or unauthorized purpose</li>
                        <li>Attempt to gain unauthorized access to our systems</li>
                        <li>Interfere with or disrupt the service or servers</li>
                    </ul>
                </div>

                <div className={styles.section}>
                    <h2 className={styles.sectionTitle}>6. Intellectual Property</h2>
                    <p className={styles.text}>
                        All content, features, and functionality of Prepal, including but not limited to text, graphics, logos, software, and study materials, are owned by Prepal and protected by copyright, trademark, and other intellectual property laws.
                    </p>
                </div>

                <div className={styles.section}>
                    <h2 className={styles.sectionTitle}>7. Limitation of Liability</h2>
                    <p className={styles.text}>
                        Prepal is provided "as is" without warranties of any kind. We do not guarantee specific test score improvements. In no event shall Prepal be liable for any indirect, incidental, special, or consequential damages arising out of your use of our service.
                    </p>
                </div>

                <div className={styles.section}>
                    <h2 className={styles.sectionTitle}>8. Termination</h2>
                    <p className={styles.text}>
                        We reserve the right to suspend or terminate your account at any time for violation of these terms or for any other reason at our discretion. You may cancel your subscription at any time through your account settings.
                    </p>
                </div>

                <div className={styles.section}>
                    <h2 className={styles.sectionTitle}>9. Changes to Terms</h2>
                    <p className={styles.text}>
                        We may modify these Terms of Service at any time. We will notify you of significant changes via email or through our platform. Continued use of Prepal after changes constitutes acceptance of the modified terms.
                    </p>
                </div>

                <div className={styles.section}>
                    <h2 className={styles.sectionTitle}>10. Contact Information</h2>
                    <p className={styles.text}>
                        If you have any questions about these Terms of Service, please contact us at:
                    </p>
                    <p className={styles.contactInfo}>
                        Email: support@prepal.com<br />
                        Address: Prepal Inc., Educational Services Division
                    </p>
                </div>

                <div className={styles.footer}>
                    <button onClick={onClose} className={styles.closeButton}>
                        Close
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default TermsOfServiceModal;
